(function () {
  function goTo(carousel, key) {
    var tabs = Array.from(carousel.querySelectorAll('[data-v6a-tab]'));
    var slides = Array.from(carousel.querySelectorAll('[data-v6a-slide]'));
    var tab = tabs.find(function (item) { return item.getAttribute('data-v6a-tab') === String(key); });
    var slide = slides.find(function (item) { return item.getAttribute('data-v6a-slide') === String(key); });
    if (!tab || !slide) return;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });
    slides.forEach(function (item) { item.classList.toggle('is-active', item === slide); });
  }

  function step(carousel, offset) {
    var tabs = Array.from(carousel.querySelectorAll('[data-v6a-tab]'));
    if (!tabs.length) return;
    var index = tabs.findIndex(function (tab) { return tab.classList.contains('is-active'); });
    if (index < 0) index = 0;
    var nextIndex = (index + offset + tabs.length) % tabs.length;
    goTo(carousel, tabs[nextIndex].getAttribute('data-v6a-tab'));
  }

  function bindControls() {
    if (window.__anymapleV8APlusControlsReady) return;
    window.__anymapleV8APlusControlsReady = true;

    // Delegation keeps the controls working when Shopify replaces section markup.
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      var control = target.closest('.v8a-linear-fluted [data-v6a-tab], .v8a-linear-fluted [data-v6a-prev], .v8a-linear-fluted [data-v6a-next]');
      if (!control) return;
      var carousel = control.closest('[data-v6a-carousel]');
      if (!carousel) return;

      event.preventDefault();
      if (control.hasAttribute('data-v6a-tab')) {
        goTo(carousel, control.getAttribute('data-v6a-tab'));
      } else if (control.hasAttribute('data-v6a-prev')) {
        step(carousel, -1);
      } else {
        step(carousel, 1);
      }
    }, true);
  }

  function initImageCarousels(root) {
    root.querySelectorAll('[data-v6a-bgc]').forEach(function (carousel) {
      if (carousel.dataset.v8aCarouselReady === 'true') return;

      var track = carousel.querySelector('[data-v6a-bgc-track]');
      var slides = Array.from(carousel.querySelectorAll('[data-v6a-bgc-slide]'));
      var dotsBox = carousel.querySelector('[data-v6a-bgc-dots]');
      if (!track || slides.length < 2 || !dotsBox) return;

      carousel.dataset.v8aCarouselReady = 'true';
      var autoplay = carousel.getAttribute('data-v6a-bgc-autoplay') === 'true';
      var index = 0;
      var timer = null;

      function go(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        Array.from(dotsBox.children).forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }

      function restart() {
        window.clearInterval(timer);
        if (autoplay) timer = window.setInterval(function () { go(index + 1); }, 4500);
      }

      dotsBox.textContent = '';
      slides.forEach(function (_slide, slideIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'v6a-bgc-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (slideIndex + 1));
        dot.addEventListener('click', function () { go(slideIndex); restart(); });
        dotsBox.appendChild(dot);
      });

      var previous = carousel.querySelector('[data-v6a-bgc-prev]');
      var next = carousel.querySelector('[data-v6a-bgc-next]');
      if (previous) previous.addEventListener('click', function () { go(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(index + 1); restart(); });

      carousel.addEventListener('mouseenter', function () { window.clearInterval(timer); });
      carousel.addEventListener('mouseleave', restart);

      var touchStartX = null;
      carousel.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
        window.clearInterval(timer);
      }, { passive: true });
      carousel.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) go(index + (deltaX < 0 ? 1 : -1));
        touchStartX = null;
        restart();
      }, { passive: true });

      go(0);
      restart();
    });
  }

  function initSection(root) {
    if (!root || root.dataset.v8aReady === 'true') return;
    root.dataset.v8aReady = 'true';

    root.querySelectorAll('[data-v6a-carousel]').forEach(function (carousel) {
      var tabs = Array.from(carousel.querySelectorAll('[data-v6a-tab]'));
      if (!tabs.length || !carousel.querySelector('[data-v6a-slide]')) return;

      var activeTab = tabs.find(function (tab) { return tab.classList.contains('is-active'); });
      var currentKey = activeTab ? activeTab.getAttribute('data-v6a-tab') : tabs[0].getAttribute('data-v6a-tab');
      goTo(carousel, currentKey);
    });

    initImageCarousels(root);

    var sectionId = root.id.replace(/^v6a-/, '');
    var mapScript = document.querySelector('[data-v8a-variant-map="' + sectionId + '"]');
    var variantMap = {};
    if (mapScript) {
      try {
        variantMap = JSON.parse(mapScript.textContent || '{}');
      } catch (error) {
        variantMap = {};
      }
    }

    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return input.value;
      return new URL(window.location.href).searchParams.get('variant');
    }

    function updateImages() {
      var map = variantMap[String(currentVariantId())];
      if (!map) return;
      root.querySelectorAll('img[data-v6a-d]').forEach(function (img) {
        var item = map[img.getAttribute('data-v6a-d')];
        if (item && item.d) img.src = item.d;
      });
      root.querySelectorAll('source[data-v6a-m]').forEach(function (source) {
        var item = map[source.getAttribute('data-v6a-m')];
        if (item && item.m) source.srcset = item.m;
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target.closest('form[action*="/cart/add"]')) window.setTimeout(updateImages, 80);
    });
    document.addEventListener('variant:change', function () { window.setTimeout(updateImages, 80); });
    updateImages();
  }

  function initAll() {
    bindControls();
    document.querySelectorAll('.v8a-linear-fluted[id^="v6a-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

